import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { noop } from '@adsk/alloy-react-helpers';

import { useTranslation } from './i18n';
import { useCollection } from './providers/CollectionProvider';
import { useSearchPanel } from './providers/SearchPanelProvider';
import EntityPickerModalEmptyState from '../../modal/EntityPickerModalEmptyState';
import EntityPickerModalNoSearchResults from '../../modal/EntityPickerModalNoSearchResults';

const SheetCustomNoData = ({ filters, clearFilters, plugin }) => {
  const { t } = useTranslation();

  const { isFeatureEnabled: enableCollectionFeature } = useCollection();
  const { resetSearchPanel } = useSearchPanel();

  const clearSearch = () => {
    clearFilters();
    resetSearchPanel();
  };

  if (filters && Object.keys(filters).length > 0) {
    return enableCollectionFeature ? (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
        title={t('NO_RESULTS_TITLE')}
        description={t('NO_RESULTS_DESCRIPTION')}
      >
        <LinkButton onClick={clearSearch}>{t('CLEAR_SEARCH')}</LinkButton>
      </EmptyState>
    ) : (
      <EntityPickerModalNoSearchResults
        clearFilters={clearFilters}
        filters={filters}
      />
    );
  }

  return (
    <EntityPickerModalEmptyState
      canCreate={false}
      plugin={plugin}
      onCreateClick={noop}
    />
  );
};

export default SheetCustomNoData;
